const daysjs = require('../utils/dayjsConfig');
var axios = require('axios');
var { error_message } = require('@managers/helpers');

const SCIROOT_WEATHER_RECORDS_PATH = 'weather_records';

export var weatherDataStatistics = (weatherData, timezone) => {
  if (weatherData) {
    var keys = Object.keys(weatherData);
    keys.sort();
    // keys.reverse();

    let informationDic = {};
    let currentCounter = 0;
    let currentDateKey = undefined;
    let currentSum = 0;

    // Use a Map to track date string -> unix timestamp for the final result
    let dateKeyToUnix = {};

    for (var currentKey in keys) {
      let currentValue = weatherData[keys[currentKey]];
      const timestamp = parseInt(keys[currentKey]);

      // Get the date in the correct timezone
      // Using .tz() once per sample to get accurate date for any timezone (including +5:30, +5:45, etc.)
      let tmpDateObject = timezone
        ? daysjs.unix(timestamp).tz(timezone)
        : daysjs.unix(timestamp);

      // Use date string (YYYY-MM-DD) as key to properly handle all timezones
      let dateKey = tmpDateObject.format('YYYY-MM-DD');

      // Check if we're starting a new day
      if (currentDateKey !== dateKey) {
        // Completing the average calculation for previous day
        if (
          currentDateKey &&
          !informationDic[dateKeyToUnix[currentDateKey]]['averageValue']
        ) {
          informationDic[dateKeyToUnix[currentDateKey]]['averageValue'] = (
            currentSum / currentCounter
          ).toFixed(2);
        }

        currentDateKey = dateKey;

        // Calculate the unix timestamp for the start of this day in the timezone
        let dayStartUnix = tmpDateObject.startOf('day').unix();
        dateKeyToUnix[dateKey] = dayStartUnix;

        // Starting a new day
        informationDic[dayStartUnix] = {
          firstValue: currentValue,
          lastValue: currentValue,
          minValue: currentValue,
          maxValue: currentValue,
          averageValue: undefined,
        };
        currentCounter = 1;
        currentSum = currentValue;
      } else {
        let dayStartUnix = dateKeyToUnix[currentDateKey];
        // Filling the weather data statistics
        if (currentValue < informationDic[dayStartUnix]['minValue']) {
          informationDic[dayStartUnix]['minValue'] = currentValue;
        }

        if (currentValue > informationDic[dayStartUnix]['maxValue']) {
          informationDic[dayStartUnix]['maxValue'] = currentValue;
        }

        informationDic[dayStartUnix]['lastValue'] = currentValue;
        currentSum += currentValue;
        currentCounter += 1;
      }
    }

    // Completing the average calculation
    if (
      currentDateKey &&
      !informationDic[dateKeyToUnix[currentDateKey]]['averageValue']
    ) {
      informationDic[dateKeyToUnix[currentDateKey]]['averageValue'] = (
        currentSum / currentCounter
      ).toFixed(2);
    }

    return informationDic;
  }

  return {};
};

export var deleteWeatherRecord = (source, startDate, recordType) => {
  return new Promise(function (resolve, reject) {
    axios
      .delete(
        SCIROOT_WEATHER_RECORDS_PATH +
          '/' +
          source +
          '?startDate=' +
          startDate +
          '&recordType=' +
          recordType,
        {}
      )
      .then(function (res) {
        resolve(res.data);
      })
      .catch(function (err) {
        console.log(error_message(err));
        reject(err);
      });
  });
};
